import {
  AutoRefreshTokenService,
  INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
  IncludeBearerTokenCondition,
  UserActivityService,
  createInterceptorCondition,
  provideKeycloak,
  withAutoRefreshToken,
} from 'keycloak-angular';
import { KeycloakConfig } from 'keycloak-js';
import { environment } from '../../../environments/environment';

const DEFAULT_SESSION_TIMEOUT = 1800000;

export const provideKeycloakAngular = (config: KeycloakConfig, sessionTimeout?: number, backendUrlPattern?: RegExp) =>
  provideKeycloak({
    config,
    initOptions: {
      onLoad: 'check-sso',
      pkceMethod: 'S256',
      silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
      redirectUri: window.location.href,
      enableLogging: !environment.production,
    },
    features: [
      withAutoRefreshToken({
        onInactivityTimeout: 'logout',
        sessionTimeout: sessionTimeout ?? DEFAULT_SESSION_TIMEOUT,
        logoutOptions: { redirectUri: window.location.origin + '/forbidden' },
      }),
    ],
    providers: [
      AutoRefreshTokenService,
      UserActivityService,
      {
        provide: INCLUDE_BEARER_TOKEN_INTERCEPTOR_CONFIG,
        useValue: [
          createInterceptorCondition<IncludeBearerTokenCondition>({
            urlPattern: backendUrlPattern ?? /^(http:\/\/localhost:5055)(\/.*)?$/i,
          }),
        ],
      },
    ],
  });
